import { HttpService } from '@services/http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EndpointParams } from '@models/utils/endpoint-params';
import { LegalPages } from '@models/index';
@Injectable()
export class PrivacyLegalNoticeService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'center', version: 1 };

    searchLegalPagesEasy(idCenter: number): Observable<LegalPages> {
        return this.get(`public/privacy-legal-notices/${idCenter}`, this.defaultEndpointParams);
    }
}
